var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullet3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86.6825,
    height: 86,
    rx: 12,
    fill: "#03836A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0144 35.5485C58.5573 32.969 56.1966 31.0712 53.4236 30.25C50.6506 29.4288 47.6788 29.7476 45.1268 31.1399V20.1184H40.8732V31.1399C38.3212 29.7476 35.3494 29.4288 32.5764 30.25C29.8034 31.0712 27.4427 32.969 25.9856 35.5485C21.7319 42.1614 32.366 62 36.6196 62C40.8732 62 40.8732 59.7957 43 59.7957C45.1268 59.7957 45.1268 62 49.3804 62C53.634 62 64.2681 42.1614 60.0144 35.5485ZM56.2925 42.999C54.9739 48.4436 52.3792 53.4473 48.7424 57.5914C48.317 57.5914 47.8279 57.371 47.4663 57.0403C46.2022 55.981 44.6257 55.4031 43 55.4031C41.3743 55.4031 39.7978 55.981 38.5337 57.0403C38.1722 57.371 37.683 57.5914 37.2576 57.5914C33.6107 53.4612 31.0156 48.4531 29.7075 43.021C29.1758 41.4119 29.0694 39.6705 29.5161 38.0173C30.1214 36.8987 30.9959 35.9615 32.0543 35.2971C33.1128 34.6327 34.3192 34.2637 35.5562 34.2259C36.7472 34.2479 37.9169 34.5345 38.9803 35.0856L40.8732 36.0775H45.1268L47.0197 35.0856C48.0831 34.5345 49.2528 34.2479 50.4438 34.2259C52.9535 34.292 55.2504 35.7248 56.484 37.9952C56.9306 39.6485 56.8242 41.3898 56.2925 42.999ZM40.8732 24.527C28.9205 31.2942 26.2195 21.8378 26.2195 21.8378C26.2195 21.8378 31.8768 13.9243 40.8732 24.527Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.4603,
    height: 64.1587,
    fill: "white",
    transform: "translate(19.1111 10.9207)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet3);
export default __webpack_public_path__ + "static/media/bullet-3.ac193a29738c4c36c79da7516c0ef61a.svg";
export { ForwardRef as ReactComponent };